import * as Tool from './tool'

const getDomain = (p, d) => Tool.getConf('DOMAIN', p, d)

// 巨量引擎oe
// ad.oceanengine.com => ad-boe.oceanengine.com
// OE: "ad-boe.oceanengine.com"
const ADOE_ORIGIN = getDomain('OE', 'ad.oceanengine.com')

// ad-toutiao
// ad.toutiao.com => ad-boe.toutiao.com
// OE: "ad-boe.toutiao.com"
const ADTT_ORIGIN = getDomain('TOUTIAO', 'ad.toutiao.com')

// 巨量引擎h5
// h5.oceanengine.com => h5-boe.oceanengine.com
const H5OE_ORIGIN = getDomain('H5', 'h5.oceanengine.com')

// 创意中心cc
// cc.oceanengine.com => ad-creative-boe.bytedance.net
// CREATIVE: "ad-creative-boe.bytedance.net"
const CC_ORIGIN = getDomain('CREATIVE', 'cc.oceanengine.com')

// 管理中心
// ad-admin.bytedance.net => ad-admin-boe.bytedance.net
// ADMIN: "ad-admin-boe.bytedance.net"
const ADMIN_ORIGIN = getDomain('ADMIN', 'ad-admin.bytedance.net')

// BP管理中心
// e.oceanengine.com => e-boe.oceanengine.com
// BPMANAGE: "e-boe.oceanengine.com"
const BPADMIN_ORIGIN = getDomain('BPMANAGE', 'e.oceanengine.com')

// 线索通
// clue.oceanengine.com => clue-boe.oceanengine.com
// CLUE: "clue-boe.oceanengine.com"
const CLUE_ORIGIN = getDomain('CLUE', 'clue.oceanengine.com')

// 橙子建站
// www.chengzijianzhan.com => www-boe.chengzijianzhan.com
// ORANGE: "www-boe.chengzijianzhan.com"
const ORANGE_ORIGIN = getDomain('ORANGE', 'www.chengzijianzhan.com')

// Teris
// tetris.byted.org => tetris-boe.byted.org
// TETRIS: "tetris-boe.byted.org"
const TETRIS_ORIGIN = getDomain('TETRIS', 'tetris.byted.org')

const VIDEO_UPLOAD_ORIGIN = getDomain('VIDEO_UPLOAD', 'https://vas-lf-x.snssdk.com')

const VIDEO_UPLOAD_LOG_ORIGIN = getDomain('VIDEO_UPLOAD_LOG', 'https://log.snssdk.com')

const VOD_ORIGIN = getDomain('VOD', '//vod.bytedanceapi.com')

const registerObj = {
  ADOE_ORIGIN,
  ADTT_ORIGIN,
  H5OE_ORIGIN,
  CC_ORIGIN,
  ADMIN_ORIGIN,
  BPADMIN_ORIGIN,
  CLUE_ORIGIN,
  ORANGE_ORIGIN,
  TETRIS_ORIGIN,
  VIDEO_UPLOAD_ORIGIN,
  VIDEO_UPLOAD_LOG_ORIGIN,
  VOD_ORIGIN
}
Tool.registerFactory(registerObj)
